var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":function($event){$event.stopPropagation();return _vm.isTimeOut.apply(null, arguments)}}},[_c('el-scrollbar',{staticClass:"page-scroll",class:_vm.isWidthState() ? 'pageWidth' : '',style:(_vm.isMobileState() ? 'width: 1500px;height: 100%' : 'width: 100%;height: 100%')},[(_vm.isReload)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18d15a44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 